import { styled } from "styled-components";

export const ButtonContainer = styled.div`
  margin: 16px 0 16px 0;
  display: flex;
`;
